module.exports = __webpack_public_path__ + "static/media/dandy-personal.c10b5903.png";